const Reports = () => import(/* webpackChunkName: "ReportsOverview" */ './containers/Reports');
const QuickSummary = () => import(/* webpackChunkName: "QuickSummary" */ './components/QuickSummary');
const AffiliateQuickSummary = () => import(/* webpackChunkName: "AffiliateQuickSummary" */ './components/AffiliateQuickSummary');
const Management = () => import(/* webpackChunkName: "Management" */ './components/Management');
const Marketing = () => import(/* webpackChunkName: "Marketing" */ './components/Marketing');
const ProfileCountries = () => import(/* webpackChunkName: "ProfileCountries" */ './components/ProfileCountries');
const ProfileCountriesDetails = () => import(/* webpackChunkName: "ProfileCountriesDetails" */ './components/ProfileCountriesDetails');

export const reportsRouting = [
    {
        path: '/reports', name: 'reports', component: Reports,
        children: [
            {path: '/', redirect: 'quick-summary'},
            {path: 'quick-summary', name: 'quick-summary', component: QuickSummary},
            {path: 'affiliate-quick-summary', name: 'affiliate-quick-summary', component: AffiliateQuickSummary},
            {path: 'management', name: 'management', component: Management},
            {path: 'marketing', name: 'marketing', component: Marketing},
            {path: 'profile-countries', name: 'profile-countries', component: ProfileCountries},
            {path: 'profile-countries-details', name: 'profile-countries-details', component: ProfileCountriesDetails}
        ]
    }
]
